/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, entity, enumeration } from '@gh/core-data';
import { JobStageListItemMapper } from '../../job-stages';
import { ContractType } from '../job.dto';
import { JobFinanceType, JobGeneralTabInfoDto } from './job-general-info.dto';
import { SalesFolderStatus } from '../../leads';

export const jobGeneralInfoMapper = entity<JobGeneralTabInfoDto>({
  salesFolderStatus: enumeration(SalesFolderStatus),
  contractType: enumeration(ContractType),
  financeType: enumeration(JobFinanceType),
  stage: JobStageListItemMapper,
  jobStages: arrayOf(JobStageListItemMapper),
});
